var viewport = 1200; var DFPPathString = ""; var keywords = ""; var ccar = ""; var GAM_rn = ""; var page_ads_dict = {}; var showFlex = false;var slots=[];  var rotate_hndl=0

function ad_isMobile() {
    return viewport <= 768;
}
function ad_isXL() { return viewport >= 1200; }

function DFPSetPaths() {

    DFPPathString = GAM_accountid + "/" + GAM_site;
    showFlex = false;
}

function initOASAd(b) {

    viewport = document.documentElement.clientWidth;
    
    DFPSetPaths();
    setDFPKeywords();
    
    var adsetup = "";
    adsetup +="<scr" + "ipt async='async' src='https://www.googletagservices.com/tag/js/gpt.js'></scr" + "ipt>\n";
    adsetup +="<script>\n";
    adsetup +="var googletag = googletag || {};\n";
    adsetup +="googletag.cmd = googletag.cmd || [];\n";
    adsetup +="</script>\n";

    adsetup +="<script>\n";
    adsetup +="googletag.cmd.push(function() {\n";
    document.write(adsetup);
    console.log(adsetup);
    
    var flexadpos = GAM_site

    if (ad_isMobile()) {
        console.log("setupDFPSlots(DFPPathString,\"mobile\")");
        setupDFPSlots(DFPPathString,"mobile");
        flexadpos += 'mobile'; 
    } else {
        console.log( "setupDFPSlots(DFPPathString,\"\")");
        setupDFPSlots(DFPPathString, "");
    }

    if (showFlex) {
        flexadpos = flexadpos.replace("test", "");
        adsetup = "   googletag.defineOutOfPageSlot('/" + GAM_accountid + "/" + flexadpos + "', 'div-gpt-ad-Full Page Flex').addService(googletag.pubads());\n";
        document.write(adsetup);
        console.log(adsetup);
    }


    adsetup = "";
    adsetup += "googletag.pubads().enableSingleRequest();\n";
    adsetup += setDFPGeoTargeting();
    adsetup +="googletag.pubads().setTargeting('PageType', ad_set_adtype).setTargeting('Category',ad_set_adsection).setTargeting('Page', ad_set_adpostid).setTargeting('keywords', ad_set_adkeywords).setTargeting('author',ad_set_adcreator).setTargeting('Business_Tag',ad_set_businesstag).setTargeting('AI_Topic_Tag',ad_set_ai_topic_tag).setTargeting('AI_User_Tag',ad_set_ai_user_tag);\n";
    adsetup +="googletag.pubads().collapseEmptyDivs();\n";
    adsetup +="googletag.enableServices();\n";
    adsetup +="});\n";
    adsetup +="</script>\n";
    document.write(adsetup);
    console.log(adsetup);

    adsetup ="DFPPathString: " + DFPPathString + "\n";
    adsetup +="ad_set_adtype: " + ad_set_adtype + "\n";
    adsetup +="ad_set_adsection: " + ad_set_adsection + "\n";
    adsetup +="ad_set_adpostid: " + ad_set_adpostid + "\n";
    adsetup +="ad_set_adcreator: " + ad_set_adcreator + "\n";
    adsetup += "ad_set_businesstag: " + ad_set_businesstag + "\n";
    adsetup += "AI_Topic_Tag: " + ad_set_ai_topic_tag + "\n";
    adsetup += "AI_User_Tag: " + ad_set_ai_user_tag + "\n";
    adsetup += "viewport: " + viewport + "\n";
    adsetup += "showFlex: " + showFlex + "\n";
    adsetup += "flexadpos: " + flexadpos + "\n";
    adsetup += "ad_isMobile: " + ad_isMobile() + "\n";
    console.log(adsetup);

    //render flex UI element
    if (showFlex) {
        document.write("<div id='div-gpt-ad-Full Page Flex' style='height: 0px;'>");
        document.write("<scr" + "ipt>");
        document.write("googletag.cmd.push(function () { googletag.display('div-gpt-ad-Full Page Flex'); });");
        document.write("</scr" + "ipt>");
        document.write("</div>");
        console.log("googletag.cmd.push(function () { googletag.display('div-gpt-ad-Full Page Flex'); });");
    }
}

function renderslot(path, size, ele, position) {
    var thispath = "/" + path;
    var pos = position.toLowerCase();
    var s;
    if (position) {
        if (pos == "amimobile_hp" || pos == "amimobile_category" || pos == "amimobile_article" || pos == "360e-outstream") { thispath += "/inline"; }
        s = "slots.push(";
        s += "googletag.defineSlot('" + thispath + "', " + size + ", '" + ele + "').setTargeting('position', ['" + position + "']).addService(googletag.pubads()";
        if (keywords) { s += ".setTargeting('URL', '" + keywords + "')"; }
        s += "));\n";
    }

    if (size=='[0,0]'){s="googletag.defineOutOfPageSlot('/" + path + "','" + ele + "').addService(googletag.pubads());\n";}

    page_ads_dict[ele] = 1;
    
    console.log("   " + s);
    document.write(s);

    // ad "Advertisement" label to those ad divs with a rendered ad
    prependAdLabel(ele);

}

function renderAd(ele,ajax) {

    if (page_ads_dict[ele] != null || ajax) {
        console.log((ajax ? "   ":'')  + 'renderAd ' + ele + '; googletag.cmd.push(function () { googletag.display(ele); });');
        googletag.cmd.push(function () { googletag.display(ele); });
    }
}

function renderajaxslot(size, ele, position, breakpoint) {

    if (typeof GAM_accountid == 'undefined') { return; }
     DFPSetPaths();

    if (ad_isMobile() && breakpoint != "mobile") { return; }

   // if (nISSequence > 1) {position = position + "_" + nISSequence;}
    console.log('renderajaxslot: path:' + DFPPathString + ';size:' + size + ';ele: ' + ele + ';position:' + position + ';breakpoint:' + breakpoint);
    googletag.cmd.push(function () {
        googletag.defineSlot('/' + DFPPathString, eval(size), ele).setTargeting('position', position).addService(googletag.pubads());
        eval(setDFPGeoTargeting());
        googletag.pubads().setTargeting('PageType', ad_set_adtype).setTargeting('Category', ad_set_adsection).setTargeting('Page', ad_set_adpostid).setTargeting('keywords', ad_set_adkeywords).setTargeting('author', ad_set_adcreator).setTargeting('Business_Tag', ad_set_businesstag).setTargeting('AI_Topic_Tag', ad_set_ai_topic_tag).setTargeting('AI_User_Tag', ad_set_ai_user_tag);
        googletag.pubads().enableSingleRequest();
        googletag.enableServices();
        googletag.pubads().collapseEmptyDivs();
        renderAd(ele,true);
    });

    // ad "Advertisement" label to those ad divs with a rendered ad
    prependAdLabel(ele);
}

function prependAdLabel(ele) {
    return;
    // ad "Advertisement" label to those ad divs with a rendered ad
    googletag.cmd.push(function () {
        googletag.pubads().addEventListener('slotRenderEnded', function (event) {

            if (ele.toLowerCase().indexOf("sponsor") > -1 || ele.toLowerCase().indexOf("logo") > -1) {
                openTag = "<div id='sponsor-label'>Sponsored by:";
            } else if (ele.toLowerCase().indexOf("native") > -1 || ele.toLowerCase().indexOf("mobile-bottom") > -1) {
                openTag = "<div id='ad-label'>";
            } else if (ele.toLowerCase().indexOf("outstream") > -1 || ele.toLowerCase().indexOf("nmgmobile") > -1) {
                openTag = "<div id='ad-label'>";

            } else {
                openTag = "<div id='ad-label'>Advertisement";
            }

            if (!event.isEmpty && event.slot.getSlotElementId() === ele) {
                $('#' + ele).prepend(openTag + "</div>");
            }
        });
    });
}

function getEPGAdIm(s) { if (s == null|| s==undefined || s=="") { return "";} return "<img style='display:none' src='" + s + (s.indexOf("?") ? "" : "?") + "&sid=" + ccar + "&rnd=" + GAM_rn + "&ru=" + escape(window.location.href) + "'/>" }
function renderEPGAdIm(s) { document.writeln(getEPGAdIm(s)) }
function renderEPGAdImAJAX(s) { return getEPGAdIm(s) };
function rotateads() {
    if (rotate_hndl > 0) { console.log('rotateads ignore'); return;}
    console.log('rotateads start');
    $("[id^=div-gpt-ad] iframe").fadeOut(500, function () { });
    rotate_hndl=window.setTimeout(do_rotateads, 650);
    return false;
}
function do_rotateads() {
    googletag.pubads().refresh(slots);
    console.log('rotateads end');
    rotate_hndl = 0;
}

function setDFPGeoTargeting(){

    //targeting for hotel and cruise pages
    var geoDataInput = GAM_query.split("&");
    var geoDataOutput = "";
    for (ii = 0; ii < geoDataInput.length - 1; ii++) {
        var geoItem = geoDataInput[ii].split("=");
        if (geoItem[1]) { geoDataOutput += ".setTargeting('" + geoItem[0] + "', ['" + geoItem[1] + "'])"; }
    }

    if (geoDataOutput != "") { geoDataOutput = "googletag.pubads()" + geoDataOutput + ";\n";}
    return geoDataOutput;
}

function setDFPKeywords(){
    return;
    var pathname = window.location.pathname;
    var querystring = window.location.search;
    if (pathname.charAt(0) == "/"){pathname = pathname.substr(1);}
    if (querystring) {
        querystring = querystring.replace(/\=/g, ' ');
        querystring = querystring.replace(/\?/g, ' ');
        querystring = querystring.replace(/\&/g, ' ');
    }    
    pathname = pathname.trim();
    querystring = querystring.trim();

    if (pathname.toLowerCase().indexOf('search') !== -1) {
        keywords = querystring
    }
    else if (pathname.toLowerCase().indexOf('home') !== -1) {
        keywords = pathname;
    }
    else {
        keywords = pathname;
        if (querystring) {pathname += " " + querystring;}
    }
    if (keywords == "Destinations/Southeast/Tampa-Meetings-Always-Up-To-Date-Planner-Guide") { keywords = "Destinations/Southeast/Tampa-Meetings";}
    if (keywords == "Destinations/International-and-US-Territories/Singapore-Meetings-Always-Up-To-Date-Planner-Guide") {keywords = "singapore-meetings-always-up-to-date";}
    
}

function hasDestination() {
    var b = false;


    return b;
}

function IsDestArticle(path) {
    return false;
}

